import { useEntryStore } from '../../store/entry/entryStore';
import { useQuery } from '@tanstack/react-query';
import { getEntry } from '../../services/predictorService';
import { isSuccess } from '../../common/serviceUtil';
import { useEventStore } from '../../store/event/eventStore';

export const useEntryPoll = (userToken?: string, predictorId?: number) => {
  const setEntry = useEntryStore((s) => s.setEntry);
  const events = useEventStore((s) => s.events);
  const entry = useEntryStore((s) => s.entry);
  const picks = useEntryStore((s) => s?.entry?.picks);
  const resultedMarkets = events
    ?.filter((event) => event.eventStartTime < Date.now())
    .map((event) => {
      return event.markets.filter((market) => market?.marketResulted);
    })
    .flat();

  const unresultedPick = picks?.some((pick) =>
    resultedMarkets?.some((market) => market.marketId === pick.marketId && !pick.resulted),
  );

  return useQuery(['getEntry', userToken, predictorId], ({ signal }) => getEntry({ userToken, predictorId, signal }), {
    onSettled: (data, error) => {
      if (isSuccess(data)) {
        setEntry(data.value);
        return;
      }
    },
    enabled: !!predictorId && !!unresultedPick && !!entry,
    refetchInterval: Number(process.env.REACT_APP_ENTRY_POLL_INTERVAL) || 2000,
  });
};
